import { render, staticRenderFns } from "./KusClientList.vue?vue&type=template&id=7ddbe5cc"
import script from "./KusClientList.vue?vue&type=script&lang=js"
export * from "./KusClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports